// roles models for handling roles
const Role = {
  Admin: "Admin",
  User: "User",
};
export default Role;
